export default __webpack_public_path__ + "images/bgflt4.75a7a4b.jpg";